export default function formatDateToSwiss(dateString) {
    const date = new Date(dateString);

    // Récupérer le jour, le mois et l'année
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Les mois commencent à 0
    const year = date.getFullYear();

    // Retourner la date formatée en "jj.mm.aaaa"
    return `${day}.${month}.${year}`;
}